import React from 'react';
import { ROLES } from 'constants/roles';

import { getIsBoatManufacturer, getIsTrailerManufacturer, getIsComponentManufacturer } from 'helpers';

import EmptyList from '../../Components/EmptyList';

export default ({
  manufacturers,
  activePage,
  rowsCount,
  handleSelectManufacturer,
  sortedBy,
  tableColumnsWidths,
  isOilDashboard,
  user,
  handleStatusChangeClick,
  isWithPaymentStatus,
  isWithCertificationStatus,
  listRequestInProcess,
  noEntrysForThisManufacturer,
}) => {
  const _getTextColourStyle = key => {
    if (sortedBy === key) return 'active';
    return '';
  };

  const _getBackgroundColourStyle = index => {
    return index % 2 ? '_background_color_pale_gray' : '_background_color_white';
  };

  const _getStatusColor = manufacturer => {
    return `list-scene__status-label_${manufacturer.active ? 'approved' : 'deactivated'}`;
  };

  const _getManufacturerType = manufacturer => {
    const isBrander = manufacturer.allRoles.indexOf(ROLES.OIL_BRANDER.serverName) !== -1;
    const isFormulator = manufacturer.allRoles.indexOf(ROLES.OIL_MANUFACTURER.serverName) !== -1;

    if (isBrander && isFormulator) {
      return (
        <React.Fragment>
          <div className='_line-height_30'>Formulator</div>
          <div className='_line-height_30'>Brander</div>
        </React.Fragment>
      );
    } else {
      return <div>{isFormulator ? 'Formulator' : 'Brander'}</div>;
    }
  };

  function getTableBody() {
    if (noEntrysForThisManufacturer) {
      if (listRequestInProcess) {
        return (
          <div className='ect-spinner _height_120'>
            <div className='ect-spinner__image' style={{ width: 50, height: 50 }} />
          </div>
        );
      } else {
        if (user.selectedInspector) {
          return <EmptyList>No manufacturers found for this inspector</EmptyList>;
        } else {
          return <EmptyList>No manufacturers found for this role</EmptyList>;
        }
      }
    } else if (!manufacturers.length) {
      return <EmptyList>No manufacturers found with selected filters.</EmptyList>;
    }

    const sliceFrom = (activePage - 1) * rowsCount;
    const sliceTo = rowsCount ? activePage * rowsCount : manufacturers.length;
    return manufacturers.slice(sliceFrom, sliceTo).map((manufacturer, index) => {
      const paymentStatus = manufacturer.checklist.itemValues.find(
        checklistItem => checklistItem.statusType === 'PAYMENT'
      );

      const completeStatus = manufacturer.checklist.itemValues.find(
        checklistItem => checklistItem.statusType === 'AGREEMENT'
      );

      const isPaid = isWithPaymentStatus && paymentStatus && paymentStatus.isChecked;

      const isComplete = completeStatus && completeStatus.isChecked;

      const isCompleteColumnShown =
        getIsBoatManufacturer(user) || getIsTrailerManufacturer(user) || getIsComponentManufacturer(user);

      return (
        <div
          id={`manufacturerRowId${manufacturer.code}`}
          key={manufacturer.code}
          onClick={handleSelectManufacturer(manufacturer)}
          className={`list-scene__table-row ${_getBackgroundColourStyle(index)}`}
        >
          <div className={`list-scene__status-bar_left ${_getStatusColor(manufacturer)}`} />

          <div
            id='manufacturerCodeField'
            className={`list-scene__table-row-element
                           list-scene__table-row-element_text-element
                           ${_getTextColourStyle('code')}
                           ${tableColumnsWidths['code']}`}
          >
            {manufacturer.code}
          </div>

          <div
            id='manufacturerNameField'
            className={`list-scene__table-row-element
          list-scene__table-row-element_place_filler
                           list-scene__table-row-element_text-element
                           ${_getTextColourStyle('name')}`}
          >
            {manufacturer.name}
          </div>

          {isOilDashboard && (
            <div
              id='manufacturerTypeField'
              className={`list-scene__table-row-element
                           list-scene__table-row-element_text-element
                           ${_getTextColourStyle('allRoles')}
                           ${tableColumnsWidths['allRoles']}`}
            >
              {_getManufacturerType(manufacturer)}
            </div>
          )}

          {isWithCertificationStatus && (
            <div
              className={`list-scene__table-row-element list-scene__table-row-element_item-element
              ${tableColumnsWidths['isCertified']} ${manufacturer.checklists ? '_flex_col _ai_start _jc_center' : ''}`}
            >
              {user.getRoleName() === ROLES.TRAILER_MANUFACTURER.readableName ? (
                <div
                  id='manufacturerCertificationStatusField'
                  className={`${
                    manufacturer.checklist.isCertified
                      ? '__nmma-certified-icon  _height_28 _margin_top_5'
                      : '__nmma-not-certified-icon _height_50'
                  }`}
                />
              ) : (
                <div
                  id='manufacturerCertificationStatusField'
                  className={`${
                    manufacturer.checklist.isCertified
                      ? '__nmma-certified-ABYC-icon  _height_28 _margin_top_5'
                      : '__nmma-not-certified-ABYC-icon _height_50'
                  }`}
                />
              )}
              {manufacturer.checklists && (
                <div
                  id='manufacturerCertificationStatusField'
                  className={`${
                    manufacturer.checklists[1].isCertified ? '__nmma-certified-icon' : '__nmma-not-certified-icon'
                  } _height_40 _margin_top_12`}
                />
              )}
            </div>
          )}

          {!user.isInspector() && (
            <div
              className={`list-scene__table-row-element list-scene__table-row-element_item-element ${tableColumnsWidths['active']}`}
            >
              <div
                id='manufacturerStatusField'
                className={`list-scene__status-label _width_60 ${_getStatusColor(manufacturer)} ${_getTextColourStyle('active')}`}
              >
                {manufacturer.active ? 'Active' : 'Inactive'}
              </div>
            </div>
          )}

          {isWithPaymentStatus && (
            <div
              id='manufacturerFeeStatusField'
              className={`list-scene__table-row-element
                           list-scene__table-row-element_text-element
                           _flex _ai_center
                           ${_getTextColourStyle('isPaid')}
                           ${tableColumnsWidths['isPaid']}`}
            >
              <div
                className={`${isPaid ? '__checkbox_checked' : '__checkbox_red-close-button'}
            _margin_right_5`}
              />
              {isPaid ? 'Paid' : 'Unpaid'}
            </div>
          )}

          {isCompleteColumnShown && (
            <div
              className={`
                list-scene__table-row-element
                list-scene__table-row-element_text-element
                _flex
                _ai_center
                ${_getTextColourStyle('isComplete')}
                ${tableColumnsWidths['isComplete']}
              `}
            >
              <div className={`${isComplete ? '__checkbox_checked' : '__checkbox_red-close-button'} _margin_right_5`} />
              {isComplete ? 'Complete' : 'Incomplete'}
            </div>
          )}

          {user.isInternal() && (
            <div
              id='brandActionsField'
              className={`list-scene__table-row-element list-scene__table-row-element_item-element
               ${tableColumnsWidths['actions']}`}
            >
              <div className='list-scene__single-action-button' onClick={handleStatusChangeClick(manufacturer)}>
                {manufacturer.active ? 'Deactivate' : 'Reactivate'}
              </div>
            </div>
          )}

          <div className={`list-scene__status-bar_right ${_getStatusColor(manufacturer)}`} />
        </div>
      );
    });
  }

  return <div className='table-body'>{getTableBody()}</div>;
};



// WEBPACK FOOTER //
// ./src/app/Scenes/DashboardScene/TableBody.jsx